// extracted by mini-css-extract-plugin
export var growableInput = "_6n-0";
export var tagContainer = "_6n-2";
export var textInput = "_6n-1";